angular.module('app.directives.checkout').directive('checkoutOrderSummary', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
    },
    controller: function ($scope) {
      const orderSummaryContainer = document.getElementById('order-summary-container');
      const SUMMARY_CONTAINER_CSS_MAX_HEIGHT = 182;

      $scope.scrollUp = () => {
        orderSummaryContainer.scrollBy(0, -20);
      };
      $scope.scrollDown = () => {
        orderSummaryContainer.scrollBy(0, 20);
      };

      $scope.scrollDownDisabled = () => {
        if (
          orderSummaryContainer.scrollHeight - orderSummaryContainer.scrollTop ===
          orderSummaryContainer.clientHeight
        ) {
          return true;
        }
        return false;
      };

      $scope.scrollUpDisabled = () => {
        $scope.summaryScrollTop = orderSummaryContainer.scrollTop;
        if ($scope.summaryScrollTop > 0) {
          return false;
        }
        return true;
      };

      $scope.scrollDisabled = () => {
        if (orderSummaryContainer.scrollHeight < SUMMARY_CONTAINER_CSS_MAX_HEIGHT) {
          return false;
        }
        return true;
      };
    },
    template: `
          <div style="border: 1px #ddd solid; border-radius:4px;padding:10px;" class="order-summary">
            <div class="order-summary-head">
              <p class="text-left" style="font-size:16px">
                Order Summary
              </p>
              <div class="order-summary-scroll btn-group btn-breadcrumb" ng-if="scrollDisabled()">
                <button class="btn btn-xs btn-default" ng-click="scrollUp()" ng-disabled="scrollUpDisabled()">
                  <i class="fa fa-caret-up"></i>
                </button>
                <button class="btn btn-xs btn-default" ng-click="scrollDown()" ng-disabled="scrollDownDisabled()">
                  <i class="fa fa-caret-down"></i>
                </button>
              </div>
            </div>
            <div id="order-summary-container">
              <table class="table order-summary-table" style="margin-bottom:0">
                <tbody>
                  <tr>
                    <th>BoxCast <span style="text-transform:capitalize">{{vm.selectedBasePlan}}</span> Plan (Streaming Subscription)</th>
                    <td class="text-right">
                      {{vm.selectedBasePlanAmount() | currency}}
                    </td>
                  </tr>
                  <tr ng-if="vm.selectedEncoder == 'app'">
                    <th>Broadcaster App
                      <div class="checkout-message">Free download from the App Store</div>
                    </th>
                    <td class="text-right">$0.00</td>
                  </tr>
                  <tr ng-if="vm.selectedEncoder == 'boxcaster'">
                    <th>BoxCaster<span ng-if="vm.boxcasterProduct.checkout_message" class="checkout-message"><br>{{vm.boxcasterProduct.checkout_message}}</span></th>
                    <td class="text-right">$399.00</td>
                  </tr>
                  <tr ng-if="vm.selectedEncoder == 'pro'">
                    <th>BoxCaster Pro<span ng-if="vm.boxcasterProProduct.checkout_message" class="checkout-message"><br>{{vm.boxcasterProProduct.checkout_message}}</span></th>
                    <td class="text-right">$2,995.00</td>
                  </tr>
                  <tr ng-if="vm.shurePromoApplied">
                    <th>Promo: FREE Shure MV88+ Video Kit</th>
                    <td class="text-right"><strike>$288.00</strike> FREE</td>
                  </tr>
                  <tr ng-repeat="addOn in vm.addOns" ng-if="addOn.selected">
                    <th>{{ addOn["title"] }}</th>
                    <td class="text-right">
                      {{ vm.checkAddOnPrice(addOn) | currency }}
                    </td>
                  </tr>
                  <tr ng-if="vm.addOns.scoreboard.selected">
                    <th>Scoreboard Assist <br> (First FREE) <span ng-if="vm.scoreboardAssistProduct.checkout_message" class="checkout-message"><br>{{vm.scoreboardAssistProduct.checkout_message}}</span></th>
                    <td class="text-right" ng-if="vm.addOns.scoreboard.oneTimeCost.quantity == 1"><del>$599</del></td>
                    <td class="text-right" ng-if="vm.addOns.scoreboard.oneTimeCost.quantity > 1">
                      {{ vm.scoreboardAssistPrice(vm.addOns.scoreboard.oneTimeCost.quantity) | currency }}</td>
                  </tr>
                  <tr ng-if="vm.addOns.smartTVApps.selected">
                    <th>Smart TV App Setup</th>
                    <td class="text-right">$1000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>`,
  };
});



// WEBPACK FOOTER //
// ./app/directives/checkout/checkout-order-summary.js